import { Icon } from '@chakra-ui/react';

export const Elaborate = (props) => (
  <Icon viewBox="0 0 24 24" boxSize="16px" color="icon.g1" {...props}>
    <g id="Elaborate">
      <g id="Group 632535">
        <g id="Group 1281">
          <g id="Group 764">
            <path
              id="Vector"
              d="M11.9901 18.9502C12.2023 18.9502 12.4057 18.8625 12.5557 18.7065L15.7557 15.3801L15.7557 15.3799C15.9101 15.225 15.9981 15.0121 16 14.7891C16.0018 14.566 15.9173 14.3515 15.7657 14.1937C15.614 14.036 15.4076 13.9483 15.193 13.9502C14.9785 13.9522 14.7736 14.0436 14.6245 14.204L11.4245 17.5305L11.4245 17.5307C11.2745 17.6866 11.1903 17.8981 11.1903 18.1186C11.1903 18.3391 11.2745 18.5506 11.4245 18.7066C11.5745 18.8625 11.778 18.9502 11.9901 18.9502L11.9901 18.9502Z"
              fill="currentColor"
            />
            <path
              id="Vector_2"
              d="M11.9902 18.9503C12.2024 18.9503 12.4058 18.8626 12.5558 18.7067C12.7058 18.5507 12.79 18.3392 12.79 18.1187C12.79 17.8982 12.7058 17.6867 12.5558 17.5308L9.35581 14.2043C9.15264 14.0003 8.86092 13.9226 8.58852 14.0003C8.31597 14.078 8.10317 14.2992 8.02842 14.5824C7.95382 14.8657 8.02829 15.1688 8.22463 15.38L11.4246 18.7065C11.5746 18.8625 11.7781 18.9503 11.9902 18.9503Z"
              fill="currentColor"
            />
          </g>
          <rect
            id="Rectangle 1084"
            width="1.6"
            height="8"
            rx="0.8"
            transform="matrix(-4.37114e-08 1 1 4.37114e-08 8 19.4502)"
            fill="currentColor"
          />
        </g>
        <g id="Group 1282">
          <g id="Group 764_2">
            <path
              id="Vector_3"
              d="M12.0099 5.04981C11.7977 5.04981 11.5943 5.13752 11.4443 5.29345L8.24432 8.61994L8.24432 8.62008C8.0899 8.77504 8.00191 8.9879 8.00003 9.21095C7.99816 9.43399 8.08267 9.64852 8.23427 9.80627C8.38602 9.96401 8.59239 10.0517 8.80695 10.0498C9.02151 10.0478 9.22641 9.95635 9.37548 9.79597L12.5755 6.46947L12.5755 6.46933C12.7255 6.3134 12.8097 6.1019 12.8097 5.88139C12.8097 5.66087 12.7255 5.44938 12.5755 5.29345C12.4255 5.13751 12.222 5.0498 12.0099 5.0498L12.0099 5.04981Z"
              fill="currentColor"
            />
            <path
              id="Vector_4"
              d="M12.0098 5.04968C11.7976 5.04968 11.5942 5.13739 11.4442 5.29333C11.2942 5.44926 11.21 5.66075 11.21 5.88127C11.21 6.10178 11.2942 6.31328 11.4442 6.46921L14.6442 9.79571C14.8474 9.99967 15.1391 10.0774 15.4115 9.99967C15.684 9.92198 15.8968 9.70076 15.9716 9.41758C16.0462 9.13425 15.9717 8.83116 15.7754 8.61995L12.5754 5.29346C12.4254 5.13753 12.2219 5.04968 12.0098 5.04968Z"
              fill="currentColor"
            />
          </g>
          <rect
            id="Rectangle 1084_2"
            width="1.6"
            height="8"
            rx="0.8"
            transform="matrix(1.31134e-07 -1 -1 -1.31134e-07 16 4.5498)"
            fill="currentColor"
          />
        </g>
      </g>
    </g>
  </Icon>
);
